const buildShareBody = ({ text, url }) => {
  return [text, url].filter(Boolean).join("\n\n");
};


export const copyTextToClipboard = async (text) => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return "copied";
    } catch (error) {
      if (error?.name === "AbortError") {
        throw error;
      }
    }
  }

  const helper = document.createElement("textarea");
  helper.value = text;
  helper.setAttribute("readonly", "true");
  helper.style.position = "absolute";
  helper.style.left = "-9999px";
  document.body.appendChild(helper);
  helper.select();
  document.execCommand("copy");
  document.body.removeChild(helper);
  return "copied";
};


export const shareContent = async ({ title, text, url }) => {
  const payload = { title, text, url };

  if (navigator.share) {
    try {
      await navigator.share(payload);
      return "shared";
    } catch (error) {
      if (error?.name === "AbortError") {
        throw error;
      }
    }
  }

  return copyTextToClipboard(buildShareBody(payload));
};


export const getShareSuccessMessage = (mode, label) => {
  return mode === "shared" ? `${label} gedeeld.` : `${label} gekopieerd naar klembord.`;
};


export const buildPlannerShareText = (planner) => {
  const sections = (planner?.days || []).map((day) => {
    const items = day.items.map((item) => `• ${item.slot_label}: ${item.recipe.title}`).join("\n");
    return `${day.label} (${day.date_iso})\n${items}`;
  });

  return [
    `Smartly Meals weekmenu voor week ${planner?.week_start || ""}`.trim(),
    ...sections,
  ].join("\n\n");
};


export const buildGroceryShareText = (grocery) => {
  const groups = (grocery?.groups || []).map((group) => {
    const items = group.items.map((item) => `• ${item.ingredient_name}: ${item.quantity} ${item.unit}`).join("\n");
    return `${group.category}\n${items}`;
  });

  return [
    `Smartly Meals boodschappenlijst voor week ${grocery?.week_start || ""}`.trim(),
    `${grocery?.item_count || 0} items · ${grocery?.summary?.covered_items_count || 0} volledig uit pantry · ${grocery?.summary?.partial_items_count || 0} deels opgevangen`,
    ...groups,
  ].join("\n\n");
};


export const buildRecipeShareText = (recipe) => {
  const ingredients = (recipe?.ingredients || [])
    .map((ingredient) => `• ${ingredient.ingredient_name}: ${ingredient.quantity} ${ingredient.unit}`)
    .join("\n");
  const steps = (recipe?.instructions || []).map((step, index) => `${index + 1}. ${step}`).join("\n");

  return [
    recipe?.title || "Smartly recept",
    recipe?.description || "",
    `Tijd: ${(recipe?.prep_time_min || 0) + (recipe?.cook_time_min || 0)} min · ${recipe?.kcal_per_serving || 0} kcal`,
    "Ingrediënten",
    ingredients,
    "Bereiding",
    steps,
  ].filter(Boolean).join("\n\n");
};